import { CLERK_COOKIE_PREFIXES } from '@lib/clerk/constants/clerk-cookie-names';

// `__session` and `__client` are HttpOnly (absent from
// document.cookie); the `__client_uat*` marker is readable and
// drives client `isSignedIn`. It matches under the `__client`
// prefix.

/**
 * Snapshots the readable client auth state for the dead Google
 * button watchdog: URL, referrer, cookie names, and the
 * divergence-revealing `__client_uat*` timestamps. Never logs a
 * token value. Shaped as a log `data` bag for `logError`.
 */
export function collectAuthDiagnostics(): Record<string, unknown> {
  if (typeof document === 'undefined') {
    return { url: '', referrer: null, cookieNames: [], clerkCookies: {} };
  }

  const pairs = document.cookie ? document.cookie.split('; ') : [];
  const cookieNames: string[] = [];
  const clerkCookies: Record<string, string> = {};

  for (const pair of pairs) {
    const eq = pair.indexOf('=');
    const name = eq === -1 ? pair : pair.slice(0, eq);
    cookieNames.push(name);

    if (!CLERK_COOKIE_PREFIXES.some(prefix => name.startsWith(prefix))) {
      continue;
    }
    // UAT is a unix timestamp (0 = signed out) — log it; redact the
    // rest so a readable token (e.g. dev `__clerk_db_jwt`) never lands
    // in logs.
    clerkCookies[name] = name.startsWith('__client_uat')
      ? eq === -1
        ? ''
        : pair.slice(eq + 1)
      : '<present>';
  }

  return {
    url: window.location.href,
    referrer: document.referrer || null,
    cookieNames,
    clerkCookies,
  };
}
